<template>
  <CRow>
    <CCol lg="12">
      <CCard v-if="billExport">
        <CCardHeader>
          <CRow v-if="billExport" class="ml-1">
            <CButton class="mr-2" @click="selectAllBill" color="light">
              <CIcon name="cil-check-alt" class="mr-2"/>Chọn tất cả</CButton>
            <CButton class="mr-2" @click="deselectAllBill" color="light">
              <CIcon name="cil-x" class="mr-2" />Bỏ chọn tất cả</CButton>
            <CButton class="mr-2" @click="deleteMemorySelected" color="light">
              <CIcon name="cil-trash" class="mr-2"/>Bỏ mục đã chọn</CButton>
            <CButton :disabled="billRecords.length <= 0" class="mr-2" @click="exportFile" color="light">
              <CIcon name="cil-cloud-download" class="mr-2"/>Xuất danh mục linh kiện</CButton>

            <CAlert
              :show.sync="dismissCountDown"
              color="success"
              fade
              class="pb-0 mb-1 pt-0 mt-2"
            >
              {{alertMessage}}!
            </CAlert>

          </CRow>
        </CCardHeader>
        <CCardBody>
          <CDataTable
            :items="billRecords"
            :fields="billHeaders"
            :key="tableBillKey"
            sorter
            pagination
          >
            <template #no-items-view>
              <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                Danh sách trống!
              </div>
            </template>

            <template #selection="{item, index}">
              <td>
                <div class="action-column">
                  <input type="checkbox"
                         v-model="item.selection"
                         class="checkbox mt-2"/>
                </div>
              </td>
            </template>

          </CDataTable>
        </CCardBody>
      </CCard>
      <CCard>
        <CCardHeader class="pb-0 mb-0">
          <CRow>
            <CCol md="4" lg="4" xl="3" xxl="3" >
              <!--<CSelect  :options="options"  :value.sync="criteria.component"/>-->
              <v-select
                v-model="selectedOption"
                :options="options"
                @input="onInputChange"
                placeholder="Lựa chọn"
              />
            </CCol>
            <CCol>
              <CInput  placeholder="Nội dung tìm kiếm"  v-model="criteria.criteria"/>
            </CCol>

            <CCol md="3" lg="3" xl="2" xxl="2" class="text-right">
              <CButton color="info" shape="pill" class="mr-1"
                       @click="searchElements">
                <CIcon name="cil-magnifying-glass"/>Tìm kiếm</CButton>
            </CCol>
            <CCol v-if="isSuper" md="3" lg="3" xl="2" xxl="2" class="text-right">
              <CButton :disabled="criteria.component==='all'"
                color="info" shape="pill" class="mr-1"
                @click="createElement">
                <CIcon name="cil-plus"/>Tạo mới</CButton>
            </CCol>

          </CRow>
          <CRow v-if="billExport" class="ml-1 mt-0 mb-2 pt-0 pb-2">
            <CButton class="mr-2" @click="selectAll" color="light">
              <CIcon name="cil-check-alt" class="mr-2"/>Chọn tất cả</CButton>
            <CButton class="mr-2" @click="deselectAll" color="light">
              <CIcon name="cil-x" class="mr-2" />Bỏ chọn tất cả</CButton>
            <CButton class="mr-2" @click="saveMemory" color="light">
              <CIcon name="cil-save" class="mr-2"/>Thêm/cập nhật mục đã chọn</CButton>
          </CRow>
        </CCardHeader>
        <CCardBody class="pt-1">
          <div>
            <p v-if="records && records.length > 0" class="pb-0 mb-0">Số lượng: {{ records.length }}</p>
            <CDataTable
              :items="records"
              :fields="visibleHeaders"
              :tableFilter="{label :'Bộ lọc: ', placeholder:'Nội dung' }"
              :itemsPerPageSelect="{label:' '}"
              :column-filter="billExport"
              :key="tableKey"
              sorter
              pagination
            >
              <template #no-items-view>
                <div style="color: #888; text-align: center; padding: 10px; font-style: italic;">
                  Danh sách trống!
                </div>
              </template>

              <template #Image="{item, index}">
                <td class="py-2">
                  <CCol class="justify-content-center">
                    <img v-if="item['Link hình ảnh'] && item['Link hình ảnh'].length > 2"
                         :src="item['Link hình ảnh']" alt="Ảnh"
                         style="width: 40px; height: 40px; margin-right: 5px;"
                         @mouseover="showImage(item['Link hình ảnh'])"
                         @mouseleave="hideImage"/>
                    <a v-if="item['Link tài liệu'] && item['Link tài liệu'].length > 2"
                       :title="records[index]['Link tài liệu']"
                       :href="records[index]['Link tài liệu']"
                       style="color: inherit; text-decoration: none;"
                       target="_blank" rel="noopener noreferrer">
                      <CIcon name="cil-description" size="lg" style="width: 25px; height: 25px"/></a>
                  </CCol>
                </td>
              </template>

              <template #Mã="{item, index}">
                <td>
                  <a href="#" @click="rowClicked(item, index)">{{ item['Mã']}}</a>
                </td>
              </template>

              <template #actions="{item, index}">
                <td>
                  <CDropdown
                    size="lg"
                    :caret="false"
                    placement="bottom-end">
                    <template #toggler>
                      <CButton variant="ghost">
                        <CIcon name="cil-list" size="lg"/>
                      </CButton>
                    </template>

                    <CDropdownItem @click="showInputRepository(item, index)">
                      <CIcon name="cil-input" class="mr-2"/>Nhập kho</CDropdownItem>
                    <CDropdownItem @click="showHistoryImport(item, index)">
                      <CIcon name="cil-history" class="mr-2"/>Lịch sử nhập kho</CDropdownItem>
                    <CDropdownItem @click="showHistoryExport(item, index)">
                      <CIcon name="cil-history" class="mr-2"/>Lịch sử xuất kho</CDropdownItem>
                    <CDropdownItem @click="showHistoryEdit(item, index)">
                      <CIcon name="cil-history" class="mr-2"/>Lịch sử chỉnh sửa</CDropdownItem>
                  </CDropdown>
                </td>
              </template>

              <template #SL="{item, index}">
                <td>
                  <div class="action-column">
                    <input type="number"
                           min="0"
                           class="qty-input"
                           v-model="item.SL"/>
                  </div>
                </td>
              </template>

            </CDataTable>
          </div>
        </CCardBody>
      </CCard>
    </CCol>

    <div v-if="hoveredImage" class="image-preview">
      <img :src="hoveredImage" class="preview-image" />
    </div>

    <CModal
      :show.sync="darkModal"
      :no-close-on-backdrop="true"
      title="Modal title 2"
      color="info"
      :centered="true"
    >
      <CRow class="m-0 p-0 pb-3">
        <CCol class="d-flex justify-content-center align-items-center">
          EES CODE: <strong>{{ecodeIndex}}</strong></CCol>
      </CRow>
      <CInput label="SL đang tồn:" type="number" min="0" :value="stockIndex" readonly
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <CInput label="SL nhập thêm:" type="number" min="0" v-model="params.add"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <CInput label="Cập nhật vị trí:" type="text" v-model="params.location"
              :addLabelClasses="'text-right'"
              :horizontal="{ label: 'col-sm-4', input: 'col-sm-8'}"/>
      <template #header>
        <strong v-if="selectedIndex !== -1" class="modal-title">
          Nhập linh kiện: {{records[selectedIndex]['Mã']}}</strong>
        <CButtonClose @click="darkModal = false" class="text-white"/>
      </template>
      <template #footer>
        <CButton color="info"
          @click="addQuantityLocation">
          <CIcon name="cil-save" class="mr-2"/>Nhập</CButton>
        <CButton @click="darkModal = false" color="secondary"><CIcon name="cil-x" class="mr-2"/>Đóng</CButton>
      </template>
    </CModal>

  </CRow>

  </template>

<script>
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
  },
  data () {
    return {
      options: [{ label: "Tất cả", value: "all" },],
      headers_all: [
        { key: 'SL', label: 'Số lượng', _style: 'width: 6rem;'},
        { key: 'Image', label: 'Ảnh / Tài liệu'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'NSX', label: 'NSX', _style:'width: 10rem;'},
        { key: 'Vị trí', label: 'Vị trí'},
        { key: 'Số lượng tồn', label: 'Lượng tồn'},
        { key: 'Số lượng đặt trước', label: ' Đặt trước'},
        { key: 'Số lượng khả dụng', label: 'Khả dụng'},
        { key: 'Ghi chú', label: 'Ghi chú'},
        { key: 'actions', label: 'Thao tác'},
      ],
      headers: [
        { key: 'Image', label: 'Ảnh / Tài liệu'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'NSX', label: 'NSX', _style:'width: 10rem;'},
        { key: 'Vị trí', label: 'Vị trí'},
        { key: 'Số lượng tồn', label: 'Lượng tồn'},
        { key: 'Số lượng đặt trước', label: ' Đặt trước'},
        { key: 'Số lượng khả dụng', label: 'Khả dụng'},
        { key: 'Ghi chú', label: 'Ghi chú'},
        { key: 'actions', label: 'Thao tác'},
      ],
      records: [],
      criteria: {
        component: 'all',
        criteria: '',
      },
      params: {
        component: '',
        part: '',
        add: 0,
        location: '',
      },
      tableKey: 0,
      tableBillKey: 0,
      isSuper: false,
      isSearchAll: true,
      currentImage: '',
      searched: false,
      hoveredImage: null,
      darkModal: false,
      selectedIndex: -1,
      stockIndex: -1,
      ecodeIndex: '',
      billExport: false,
      billHeaders: [
        { key: 'selection', label: 'Chọn', _style: 'width: 3rem;'},
        { key: 'Nhóm linh kiện', label: 'Nhóm linh kiện'},
        { key: 'EES CODE', label: 'Mã EES'},
        { key: 'Mô tả',  label: 'Mô tả'},
        { key: 'Mã', label: 'Mã NSX'},
        { key: 'NSX', label: 'NSX'},
        { key: 'SL', label: 'Số lượng'},
      ],
      billRecords: [],
      dismissCountDown: 0,
      alertMessage: '',
      selectedOption: null,
    }
  },
  created() {
    this.getSuper()
    this.getTypes()
    if(this.$route.query.searched) {
      this.criteria.component = this.$route.query.component
      this.criteria.criteria = this.$route.query.criteria
      this.searchElements()
    }
    if(this.$route.query.request) {
      this.billExport=true
    }
  },
  computed: {
    visibleHeaders() {
      if (this.billExport) {
        return this.headers_all;
      }
      return this.headers
    },
  },
  methods: {
    getSuper() {
      const role = localStorage.getItem('role')
      this.isSuper = ((role === 'root') || (role === 'super'))
    },
    getTypes() {
      this.$request.get(
        '/api/repo/search').
      then(res => {
        var apiOptions=[]
        if(res.data.types) {
           apiOptions = res.data.types.map(item => ({
            label: item['label'],
            value: item['name'],
          }));
        }

        // Prepend a predefined option
        const predefinedOption = { label: "Tất cả", value: "all" };
        apiOptions.unshift(predefinedOption);
        this.options = apiOptions
        // console.log(this.options);
        if(this.$route.query.searched) {
          let index = this.options.findIndex(item => item.value === this.$route.query.component);
          if (index > -1 && this.options.length > index) {
            this.selectedOption=this.options[index]
            // console.log('set selectedOption', this.selectedOption)
          }
        }
      })
    },
    searchElements() {
      this.records = []
      this.searched = true
      this.isSearchAll = this.criteria.component === 'all'
      // console.log(this.criteria.component, this.isSearchAll)
      this.$request.post(`/api/repo/search`, this.criteria).
      then((res) => {
        if(res.data.status === 'success') {
          this.records = res.data.records;
        }
        // console.log('records: ', this.records);
      });
      // console.log(this.criteria);
    },
    createElement() {
      //// console.log('request create element', this.criteria);
      if(this.criteria.component === 'all') {
        return
      }

      this.$router.push({
        path: '/component/mod',
        query: {
          component: this.criteria.component,
          part: null,
          searched: true,
        }
      });
    },
    editElement(item) {
      this.$router.push({
        path: '/component/mod',
        query: {
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          part: item['Mã'],
          searched: true,
        }
      });
    },
    rowClicked (item, index) {
      this.editElement(item)
    },
    searchOn(name) {
      /*// console.log('request search on', name)*/
      this.criteria.component=name
      this.searchElements()
    },
    documentClicked(item, index) {
      /*// console.log('document clicked', item, index)*/
    },
    showImage(image) {
      this.hoveredImage = image;
    },
    hideImage() {
      this.hoveredImage = null;
    },
    showHistoryImport(item, index) {
      // console.log('showHistoryImp: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'import',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showHistoryExport(item, index) {
      // console.log('showHistoryExport: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'export',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showHistoryEdit(item, index) {
      // console.log('showHistoryEdi: ', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'edit',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showReserve(item, index) {
      // console.log('showReserve', item, index);
      this.$router.push({
        path: '/component/history',
        query: {
          action: 'reserve',
          part: item['Mã'],
          component: item['Nhóm linh kiện'],
          criteria: this.criteria.criteria,
          searched: this.searched,
        }
      })
    },
    showInputRepository(item, index) {
      // console.log('showInputRepository: ', item, index);
      this.params.component = item['Nhóm linh kiện']
      this.params.part = item['Mã'];
      this.getComponent(this.params)
      this.darkModal=true;
      this.selectedIndex = index;
    },
    getComponent(params) {
      // console.log('do request with params: ', params)
      this.$request.get(`/api/repo/mod`, {params}).
      then(res => {
        if(res.data.headers) {
          //// console.log(res.data.values);
          let indexStock = res.data.headers.findIndex(item => item.label.includes("Số lượng tồn"));
          let indexLocation = res.data.headers.findIndex(item => item.label.includes("Vị trí"));
          let indexCode = res.data.headers.findIndex(item => item.label.includes("EES CODE"));
          this.stockIndex = res.data.values[indexStock]
          this.params.location = res.data.values[indexLocation]
          this.ecodeIndex = res.data.values[indexCode]
        } else {
          // console.log('response invalid: ', res.data)
        }
      })
    },
    addQuantityLocation(){
      this.$request.post(`/api/repo/add`, this.params).then(res=>{
        if(res.data.status === 'success'){
          this.$swal.fire({
            icon: "success",
            title: "Nhập kho",
            text: "Nhập kho: " + this.params.part + " thành công" ,
          });
          this.params.add=0
          this.searchElements()
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Nhập kho",
            text: "Nhập kho lỗi: " + this.params.part +
              " lỗi: " + res.data.status,
          });
        }
      })
      this.darkModal=false;
    },
    selectAll() {
      this.tableKey++
      // console.log('selectAll')
      this.records.forEach(item => {
        item['SL'] = 100;
      });
    },
    selectAllBill() {
      this.tableBillKey++
      // console.log('selectAllBill')
      this.billRecords.forEach(item => {
        item.selection = true;
      });
    },
    deselectAll() {
      this.tableKey++
      // console.log('deselectAll')
      this.records.forEach(item => {
        item['SL'] = 0;
      });
    },
    deselectAllBill() {
      this.tableBillKey++
      // console.log('deselectAll')
      this.billRecords.forEach(item => {
        item.selection = false;
      });
    },
    saveMemory() {
      const selectedItems = this.records.filter(item => Number(item['SL']) > 0);
      // console.log('saveMemory', selectedItems.length)
      if (selectedItems.length > 0) {
        this.$request.post(`/api/repo/addmemory`, selectedItems).then(res=>{
          if(res.data.status === 'success'){
            this.billRecords = res.data.bill_data;
            // console.log(res.data.bill_data);
            this.showAlertMessage(3, 'Thêm/cập nhật mục linh kiện thành công')
          }
        })
      }
    },
    deleteMemoryAll() {
      // console.log('deleteMemoryAll')
      this.$request.post(`/api/repo/delmemoryall`).then(res=>{
        if(res.data.status === 'success'){
          this.billRecords = res.data.bill_data;
        }
      })
    },
    deleteMemorySelected() {
      const selectedItems = this.billRecords.filter(item => item.selection === true);
      // console.log('deleteMemorySelected')
      this.$request.post(`/api/repo/delmemory`, selectedItems).then(res=>{
        if(res.data.status === 'success'){
          this.billRecords = res.data.bill_data;
          this.deselectAllBill()
        }
      })
    },
    exportFile() {
      // console.log('exportFile')
      this.$swal.fire({
        title: "Xuất tệp danh mục linh kiện?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/repo/export`).then(res => {
            if (res.data.status === 'success' && res.data.filename) {
              this.downloadFile(res.data.filename);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Xuất tệp",
                text: "Xuất tệp lỗi: " + res.data.status,
              });
            }
          })
        }
      })
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/repo/downloadbill/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
    onInputChange(value) {
      // console.log('Selected value changed:', value.value, this.selectedOption)
      if(value) {
        this.criteria.component = value.value
      } else {
        this.criteria.component = "all"
      }
    },
    showAlertMessage(second, message) {
      this.dismissCountDown = Number(second);
      this.alertMessage = message;
      // console.log('showAlertMessage', message, second);
    }
  }
}
</script>

<style scoped>
.checkbox {
  width: 20px;
  height: 20px;
  margin: 0;
}

.qty-input {
  width: 80px; /* Max width for 4 characters */
  text-align: center;
  padding: 5px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.qty-input:focus {
  outline: none;
  border-color: #007bff;
}

.image-preview {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
}

.preview-image {
  max-width: 500px;
  max-height: 500px;
}
</style>
